import React from "react";
import RequestPasswordResetForm from "@components/Form/RequestPasswordResetForm";
import FormWrapper from "@components/Wrappers/FormWrapper";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const RequestPasswordResetPage = () => {

    return (
        <VersionedLayout minimal>
            <FormWrapper pageTitle="Request Password Reset">
                <RequestPasswordResetForm/>
            </FormWrapper>
        </VersionedLayout>
    );
};

export default RequestPasswordResetPage;
